import React, { useState } from 'react';
import { formatAmountForInput } from '../../utils/Utils';
import COP from '../../assets/currency/copu.png';
import USD from '../../assets/currency/usd.png';


const InputAmount = ({ nameCurrency = 'COP', onChange = () => { }, value, error = false, currency, readOnly = false, title = 'Cargas', errorMessage, loading = false, select = false, setCurrency, className = '', inputFontSizeClass = '' }) => {
    const [open, setOpen] = useState(false)
    const handleSelect = (selectedCurrency) => {
        console.log("selectedCurrency", selectedCurrency);
        setCurrency(selectedCurrency)
        setOpen(false);
    };

    const formatAmount = (value, separator = ',') => {
        const numericValue = value.replace(/[^0-9.]/g, '');
        const [integerPart, decimalPart] = numericValue.split('.');
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

        return decimalPart !== undefined ? `$${formattedInteger}.${decimalPart}` : `$${formattedInteger}`;
    };

    return (
        <div className={`w-full rounded-xl ${className}`}>
            <div className={`w-full h-full p-3 bg-[#26262d] border ${error ? `border-[#e4847f]` : `border-[#5E5E63]`} rounded-xl flex flex-col justify-between`}>
                <p className="text-base text-[#8A8A8E] text-end flex font-semibold tracking-tight leading-5">
                    {title}
                </p>
                <div className="w-full h-full flex flex-row justify-between items-center">
                    <div className="flex items-center w-full">
                        {!loading && <input
                            className={`${inputFontSizeClass ? inputFontSizeClass : "text-[20px]"} text-left font-bold traking-[-0.44px] leading-[28.6px] bg-[transparent] ${readOnly ? `text-[#8A8A8E]` : `text-white`} flex w-full`}
                            placeholder="$ 0.00"
                            readOnly={readOnly}
                            value={value && currency === 'COP' ? (formatAmount(value, ',')) : value && currency === 'USD' ? (formatAmount(value, '.')) : ''}
                            onChange={(e) => {
                                const rawValue = e.target.value.replace(/[^0-9]/g, '');
                                onChange(rawValue);
                            }}
                        />}
                        {loading && <div className="spinner-border-white animate-spin w-8 h-8 border-2 border-white border-t-transparent rounded-full"></div>}
                    </div>
                    <div className="relative flex-shrink-0">
                        {(currency === 'COP' || currency === 'USD') && (
                            <div
                                className="w-24 h-10 px-2 py-2 bg-[#5E5E6329] rounded-lg flex flex-row gap-2 justify-center items-center cursor-pointer"
                                onClick={select ? () => setOpen(!open) : null}
                            >
                                <img
                                    src={currency === 'COP' ? COP : USD}
                                    width={20}
                                    height={20}
                                    alt="img currency"
                                />
                                <p className="text-[14px] font-bold tracking-[-0.44px] leading-[28.6px]">
                                    {currency === 'COP' ? nameCurrency : 'USD'}
                                </p>
                                {select && <svg
                                    className={`w-5 h-5 transition-transform duration-500 ${open ? "rotate-180" : "rotate-0"}`}
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="currentColor"
                                    style={{ stroke: "white", pointerEvents: "none" }}
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        strokeWidth="2"
                                        d="M19 9l-7 7-7-7"
                                    />
                                </svg>}
                            </div>
                        )}
                        {open && (
                            <div className="absolute top-12 left-0 w-32 bg-[#2b2a32] shadow-lg rounded-lg z-50 text-white p-2">
                                <button
                                    className="w-full px-4 py-3 text-left flex items-center gap-2 rounded-lg hover:bg-[#33333b]"
                                    onClick={() => handleSelect('COP')}
                                >
                                    <img src={COP} width={20} height={20} alt="COP" />
                                    <span>{nameCurrency}</span>
                                </button>
                                <button
                                    className="w-full px-4 py-3 text-left flex items-center gap-2 rounded-lg hover:bg-[#33333b]"
                                    onClick={() => handleSelect('USD')}
                                >
                                    <img src={USD} width={20} height={20} alt="USD" />
                                    <span>USD</span>
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            {error && <p className="text-start text-sm text-[#e4847f] mt-1">{errorMessage}</p>}
        </div>
    );
};

export default InputAmount;
